import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Sentry Error Tracking
import * as Sentry from "@sentry/react";

// Initialize Sentry (set DSN in production)
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  console.log('[SENTRY] Frontend error tracking initialized');
}

// LogRocket Session Replay (set in production)
const LOGROCKET_APP_ID = process.env.REACT_APP_LOGROCKET_ID || '';
if (LOGROCKET_APP_ID) {
  import('logrocket').then(LogRocket => {
    LogRocket.default.init(LOGROCKET_APP_ID);
    console.log('[LOGROCKET] Session replay initialized');
    
    // Connect LogRocket to Sentry
    if (SENTRY_DSN) {
      LogRocket.default.getSessionURL(sessionURL => {
        Sentry.setTag('logrocket', sessionURL);
      });
    }
  });
}

// Suppress PostHog cross-origin iframe errors in React error overlay
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('cross-origin frame')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Suppress error overlay for PostHog errors
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('cross-origin frame')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
